// src-mlr-chakra/views/error/error.view.js
import config from 'app/config';
import './error.scss';

class ErrorController {

  // Ensure all dependencies are correctly injected for minification
  static $inject = ["$sce"];

  /** @ngInject */
  constructor($sce) {
    this.config = config;
    this.path = $sce.trustAsResourceUrl(`${config.pubPath}/error.tpl.html`);
  }
}

class ErrorComponent {
  constructor() {
    this.selector = 'error';
    this.template = '<div ng-include="$ctrl.path"></div>';
    this.controller = ErrorController;
  }
}

export default angular
.module("error.view", [])
.component("error", new ErrorComponent())
.name;
